exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-project-users-modal .role-tag {\n  padding: 2px 8px;\n  margin: 2px;\n  border-radius: 4px;\n  font-size: 12px;\n  display: inline-block;\n}\n.edit-project-users-modal .role-tag.global-role {\n  background-color: #f0f0f0;\n  color: #666;\n}\n.edit-project-users-modal .role-tag.project-role {\n  background-color: #1890ff;\n  color: #fff;\n}\n.edit-project-users-modal .role-tag .close-icon {\n  margin-left: 4px;\n  cursor: pointer;\n}\n", ""]);

// exports
